export default "__VITE_ASSET__PZl7AkVz__"